<template>
  <div class="border rounded-lg">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h3 class="text-dark">
            {{ title }}
          </h3>
        </div>
      </div>

      <vue-apex-charts
        type="pie"
        width="100%"
        height="400"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import { get } from "lodash";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  name: "PartnersChart",
  components: {
    VueApexCharts,
    vSelect,
  },
  data() {
    return {
      chartOptions: {
        colors: [
          'rgba(7, 125, 188, 1)',
          'rgba(101, 163, 13, 1)',
          'rgba(7, 125, 188, 0.7)',
          'rgba(101, 163, 13, 0.7)',
          'rgba(75, 75, 75, 0.2)',
          'rgba(7, 125, 188, 0.6)',
          'rgba(101, 163, 13, 0.6)',
        ],
      },
      loading: false,
      graphYear: new Date().getFullYear(),
      series: [],
      title: ""
      
    }
  },

  created() {
    this.fetchPartnersGraphData()
  },
  methods: {
    async fetchPartnersGraphData(){
      try {
        this.loading = true; 

        const request = await this.useJwt().mainService.dashboard.fetchPartnersGraph();
        
        const { data } = request.data;
        this.series = data.data.map(partner => partner.count);

   
        this.chartOptions = {
          chart: {
            width: "100%",
            type: 'pie',
          },
          labels: data.data.map(partner => partner._id),
        }
        this.title = data.name
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
